<script type="text/javascript">
import Vue from 'vue';

let urEventBus = new Vue();
export default urEventBus;
</script>
